export default __webpack_public_path__ + "static/media/lost-found-pet.0c93f18c.jpg";